import React from "react";
import { Box, Flex, Portal } from "@chakra-ui/react";
import { useColorTheme } from "contexts/color-theme";
import { useHeaderHeight } from "contexts/header-height";
import { AnimatePresence } from "framer-motion";
import { MotionBox } from "ui/chakra-motion";
import { MobileNavItem } from "./mobile-nav-item";
import { CtaButtons } from "./cta-buttons";
import { type NavTabProps } from "./data";

type MobileNavProps = {
  tabs: NavTabProps[];
  isOpen: boolean;
  onToggleNav: () => void;
};

export function MobileNav({ tabs, isOpen, onToggleNav }: MobileNavProps) {
  const { headerHeight } = useHeaderHeight();
  const { theme, bgColor } = useColorTheme();
  return (
    <Box display={{ lg: "none" }} pos="relative">
      <Portal>
        <AnimatePresence>
          {isOpen && (
            <MotionBox
              position="fixed"
              display="flex"
              flexDir="column"
              top={`${headerHeight}px`}
              bg={bgColor}
              width="100vw"
              height={`calc(100vh - ${headerHeight}px)`}
              overflowY="auto"
              zIndex="overlay"
              initial={{
                x: "100%",
              }}
              animate={{
                x: 0,
                transition: {
                  duration: 0.15,
                },
              }}
              exit={{
                x: "100%",
                transition: {
                  duration: 0.15,
                },
              }}
            >
              <Box flex={1} pt="bigger" pb="small" overflowY="auto">
                {tabs.map((navItem, index) => (
                  <Flex
                    key={navItem.label}
                    direction="column"
                    borderBottom="1px"
                    borderColor={index === tabs.length - 1 ? "transparent" : `brand.header.border.${theme}`}
                    color={`brand.text.${theme}`}
                    py="smallest"
                    px="small"
                  >
                    <MobileNavItem {...navItem} onToggleNav={onToggleNav} />
                  </Flex>
                ))}
              </Box>

              <CtaButtons
                hasJustifiedButtons
                flex="none"
                minHeight={0}
                mx="containerPx.mobile"
                pt="small"
                pb="biggest" // Leave bottom space for OneTrust :'(
              />
            </MotionBox>
          )}
        </AnimatePresence>
      </Portal>
    </Box>
  );
}
